import { useState } from "react";
import styled from "styled-components";

import ActivitiesCell, { ActivityCellProps } from "../cell/ActivitiesCell";
import { Color } from "@adoptaunabuelo/react-components";
import { ChevronRight, ChevronLeft } from "lucide-react";
import media from "styled-media-query";

const Container = styled.div`
	display: flex;
	${media.lessThan("medium")`
        display: none;
    `};
`;
const ContainerMobile = styled.div`
	display: none;
	flex: 1;
	overflow-y: scroll;
	width: 100vw;
	margin: 0px -24px;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
	${media.lessThan("medium")`
        display: flex;
    `};
`;
const CellView = styled.div`
	display: flex;
	padding: 0px 24px;
	gap: 16px;
`;
const DirectionView = styled.div`
	display: flex;
	flex: 1;
	align-items: flex-end;
`;
const DirectionButton = styled.div<{ $disabled: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	width: 40px;
	border-radius: 100px;
	border: 1px solid ${Color.line.soft};
	cursor: ${(props) => (props.$disabled ? "unset" : "pointer")};
	background-color: white;
	opacity: ${(props) => (props.$disabled ? 0.3 : 1)};
	&:hover {
		background-color: ${Color.line.soft};
	}
`;

const TestimonyList = (props: Props) => {
	const [index, setIndex] = useState(0);

	const onPreviousClick = () => {
		if (index !== 0) setIndex(index - 1);
	};

	const onNextClick = () => {
		if (index !== props.testimonies.length - 1) setIndex(index + 1);
	};

	return (
		<>
			<Container>
				<ActivitiesCell {...props.testimonies[index]}>
					<DirectionView>
						<DirectionButton
							style={{ marginRight: 8 }}
							$disabled={index === 0}
							onClick={onPreviousClick}
						>
							<ChevronLeft />
						</DirectionButton>
						<DirectionButton
							$disabled={index === props.testimonies.length - 1}
							onClick={onNextClick}
						>
							<ChevronRight />
						</DirectionButton>
					</DirectionView>
				</ActivitiesCell>
			</Container>
			<ContainerMobile>
				<CellView>
					{props.testimonies.map((item, index) => (
						<ActivitiesCell key={`activity-${index}`} {...item} />
					))}
				</CellView>
			</ContainerMobile>
		</>
	);
};
export default TestimonyList;
export interface Props {
	testimonies: ActivityCellProps[];
}
